export default __webpack_public_path__ + "static/media/saket.68e60b5e.jpg";